<template>
  <div class="main-content">
    <the-header :title="t('Change password')"/>
    <titan-form :schema="schema"
                :model="modelData"
                v-on:saveData="saveData()"
                :editable="editable"
    />
  </div>
</template>

<script>
    import TitanForm from '../../../core/Form/Form'
    import VueFormGenerator from 'vue-form-generator';
    import TheHeader from '../../../admin/Layout/TheHeader';

    export default {
        name: 'ChangePassword',
        components: {
            TheHeader,
            TitanForm
        },
        created() {
            this.initData();
        },
        data() {
            return {
                loading: true,
                modelData: {},
                schema: [
                    {
                        name: this.t('Change password'),
                        type: 'main',
                        fields: [
                            {
                                type: 'password',
                                styleClasses: 'col-6',
                                label: this.t('Password'),
                                model: 'password',
                                required: true,
                                validator: function (value, field, model) {
                                    if (model.hasOwnProperty('password') && model.password && model.password.length > 0) {
                                        if (model.password.length < 6) {
                                            return [this.t('Password is too short. Please choose a password with at least 6 characters')];
                                        }
                                        if (model.password.length > 40) {
                                            return [this.t('Password is too long. Please choose a password no longer than 40 characters')];
                                        }
                                    } else {
                                        return VueFormGenerator.validators.required(value, field, model);
                                    }
                                }
                            }, {
                                type: 'input',
                                inputType: 'password',
                                styleClasses: 'col-6',
                                label: this.t('Repeat password'),
                                model: 'repeatPassword',
                                required: true,
                                max: 40,
                                min: 6,
                                validator: function (value, field, model) {
                                    if (model.password !== model.repeatPassword) {
                                        return [this.t('Passwords are not equal')];
                                    }
                                    return VueFormGenerator.validators.required(value, field, model);
                                }
                            }
                        ]
                    }
                ]
            }
        },
        computed: {
            editable() {
                return this.hasPermission('NurseTitan', 'U');
            }
        },
        methods: {
            initData() {
                this.modelData = {
                    'id': this.$route.params.id,
                    'password': null,
                    'repeatPassword': null
                }
            },
            saveData() {
                this.$store.dispatch('users/update', this.modelData).then(response => {
                    this.$store.dispatch('alert/success', this.t('Password changed'));
                    // if(this.$route.name !== 'subUserEdit') {
                    //     this.$router.push({name: 'subUserEdit', params: {id: response.id}});
                    // }
                }).catch(error => {
                    this.$store.dispatch('alert/warning', error.data.status);
                });
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/private/subuser/ChangePassword.vue